import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { translate } from '@openclassrooms/translations';
import { isCurrentPath, ROUTES } from '@openclassrooms/routing';
import Typography from '@classify/react-core-components/Typography';
import useMainNavigation from '../../hooks/useMainNavigation';
import HeaderDropDown from './HeaderDropDown';
import HeaderDropDownGroup from './HeaderDropDown/HeaderDropDownGroup';
import HeaderDropDownOverTitle from './HeaderDropDown/HeaderDropDownOverTitle';
interface Props {
  name: string;
  onClick?: () => void;
}
const noop = () => {};
const TrainingDropDownMenu = t0 => {
  const $ = _c(33);
  const {
    name,
    onClick: t1
  } = t0;
  const onClick = t1 === undefined ? noop : t1;
  const [isClient, setIsClient] = useState(false);
  const navigationConfig = useMainNavigation();
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsClient(true);
    };
    t3 = [];
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = translate("main_header.training_programs.dropdown.title");
    t5 = translate("main_header.training_programs.dropdown.text");
    $[2] = t4;
    $[3] = t5;
  } else {
    t4 = $[2];
    t5 = $[3];
  }
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <HeaderDropDown.Title title={t4} subTitle={t5}><a href={ROUTES.OFFERS.INDEX} rel="nofollow" data-event="Navigation|Redirection::Internal|Trainings comparison"><Typography variant="hyperlinkSmall" color="interaction.enabled">{translate("main_header.training_programs.dropdown.compare_offers")}</Typography></a></HeaderDropDown.Title>;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <HeaderDropDownOverTitle title={{
      content: translate("main_header.training_programs.dropdown.paths.overline"),
      index: 0
    }} />;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  const t8 = navigationConfig.PATHS.path;
  let t9;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = translate("main_header.training_programs.dropdown.paths.text");
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  let t10;
  if ($[7] !== isClient || $[8] !== navigationConfig.PATHS.path) {
    t10 = isClient && isCurrentPath(navigationConfig.PATHS.path);
    $[7] = isClient;
    $[8] = navigationConfig.PATHS.path;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  const t11 = navigationConfig.PATHS.dataEvent;
  let t12;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = translate("main_header.training_programs.dropdown.paths.title");
    $[10] = t12;
  } else {
    t12 = $[10];
  }
  let t13;
  if ($[11] !== navigationConfig.PATHS.dataEvent || $[12] !== navigationConfig.PATHS.path || $[13] !== onClick || $[14] !== t10) {
    t13 = <HeaderDropDownGroup>{t7}<HeaderDropDown.Item onClick={onClick} path={t8} subTitle={t9} isActive={t10} data-event={t11}>{t12}</HeaderDropDown.Item></HeaderDropDownGroup>;
    $[11] = navigationConfig.PATHS.dataEvent;
    $[12] = navigationConfig.PATHS.path;
    $[13] = onClick;
    $[14] = t10;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <HeaderDropDownOverTitle title={{
      content: translate("main_header.training_programs.dropdown.courses.overline"),
      index: 1
    }} />;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  const t15 = navigationConfig.COURSES.path;
  let t16;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = translate("main_header.training_programs.dropdown.courses.text");
    $[17] = t16;
  } else {
    t16 = $[17];
  }
  let t17;
  if ($[18] !== isClient || $[19] !== navigationConfig.COURSES.path) {
    t17 = isClient && isCurrentPath(navigationConfig.COURSES.path);
    $[18] = isClient;
    $[19] = navigationConfig.COURSES.path;
    $[20] = t17;
  } else {
    t17 = $[20];
  }
  const t18 = navigationConfig.COURSES.dataEvent;
  let t19;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = translate("main_header.training_programs.dropdown.courses.title");
    $[21] = t19;
  } else {
    t19 = $[21];
  }
  let t20;
  if ($[22] !== navigationConfig.COURSES.dataEvent || $[23] !== navigationConfig.COURSES.path || $[24] !== onClick || $[25] !== t17) {
    t20 = <HeaderDropDownGroup>{t14}<HeaderDropDown.Item onClick={onClick} path={t15} subTitle={t16} isActive={t17} data-event={t18}>{t19}</HeaderDropDown.Item></HeaderDropDownGroup>;
    $[22] = navigationConfig.COURSES.dataEvent;
    $[23] = navigationConfig.COURSES.path;
    $[24] = onClick;
    $[25] = t17;
    $[26] = t20;
  } else {
    t20 = $[26];
  }
  let t21;
  if ($[27] !== t13 || $[28] !== t20) {
    t21 = [t13, t20];
    $[27] = t13;
    $[28] = t20;
    $[29] = t21;
  } else {
    t21 = $[29];
  }
  let t22;
  if ($[30] !== name || $[31] !== t21) {
    t22 = <HeaderDropDown name={name} title={t6} items={t21} />;
    $[30] = name;
    $[31] = t21;
    $[32] = t22;
  } else {
    t22 = $[32];
  }
  return t22;
};
export default TrainingDropDownMenu;